export default class LanguageSwitcher {
    constructor() {
        this.DOM = {
            container: document.querySelector('.Languages'),
            current: document.querySelector('.Languages__current'),
            dropdown: document.querySelector('.Languages__dropdown'),
            links: document.querySelectorAll('.language_link')
        }

        if (!this.DOM.container) return

        this.isOpen = false
        this.bindEvents()
    }
    
    bindEvents() {
        this.DOM.current.addEventListener('click', (e) => {
            e.stopPropagation()
            this.toggleDropdown()
        })

        this.DOM.links.forEach(link => {
            link.addEventListener('click', (e) => {
                // Laisse la navigation se faire normalement
                this.closeDropdown()
            });
        });
        document.addEventListener('click', (e) => {
            if (!this.DOM.container.contains(e.target)) {
                this.closeDropdown()
            }
        })
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') this.closeDropdown()
        })
    }
    
    toggleDropdown() {
        this.isOpen = !this.isOpen
        this.DOM.container.classList.toggle('is-open', this.isOpen)
    }
    
    closeDropdown() {
        this.isOpen = false
        this.DOM.container.classList.remove('is-open')
    }
}
